import { Layout, Tab, Tabset, } from "@mcleod/components";

export abstract class AutogenLayoutFactoringPortal extends Layout {
    layout1: Layout;
    layout2: Layout;
    tabPaymentsDue: Tab;
    tabPaymentsReceived: Tab;
    tabset1: Tabset;
}
